<template>
  <section class="loginForm_wrapper guest wrapper soft">
    <img v-if="event.login_image_url" :src="event.login_image_url" alt="background" class="background_img" />
    <div class="loginForm_inner">
      <div class="loginForm_header">
        <h1>{{ event.name }}</h1>
        <p>開催日時 {{ $store.getters["event/formattedEventPeriod"] }}</p>
      </div>
      <div class="loginForm_body">
        <div class="form_title inner">
          <span class="">招待者ログイン</span>
        </div>
        <validation-observer ref="observer" v-slot="{handleSubmit, invalid}" class="form_body">
          <div class="inner">
            <form @submit.prevent="handleSubmit(login)">
              <div v-if="message">
                <span style="color: #ff0000;">{{ message }}</span>
              </div>

              <validation-provider rules="required|alpha_num|length:6" v-slot="{errors}" name="認証コード1" class="form-group">
                <label for="authCode_one">認証コード1</label>
                <input type="text" id="authCode_one" name="auth_code_one" v-model="loginForm.auth_code_one" />
                <ul v-if="errors.length">
                  <li v-for="(error, key) in errors" :key="key" class="error">{{ error }}</li>
                </ul>
              </validation-provider>

              <validation-provider rules="required|alpha_num|length:6" v-slot="{errors}" name="認証コード2" class="form-group">
                <label for="authCode_two">認証コード2</label>
                <input type="text" id="authCode_two" name="auth_code_two" v-model="loginForm.auth_code_two" />
                <ul v-if="errors.length">
                  <li v-for="(error, key) in errors" :key="key" style="color: #ff0000;">{{ error }}</li>
                </ul>
              </validation-provider>

              <div class="button_area">
                <button class="btn" type="submit" :disabled="invalid">ログイン</button>
              </div>
            </form>
          </div>
        </validation-observer>
      </div>
      <div class="login_guidance">
        <RawHtml :text="event.login_guidance" />
        <!--ToDo https://valeur.backlog.jp/view/YOSHIDA_VIRTUAL-590 イベント後、戻す-->
        <p v-if="!(Number(this.event.id) === Number(this.$config.app.noneLogoEventId))">
          当システムではビデオ会議ルームをご利用の際にはマイクの接続が必要です。お使いの機器にマイクが接続されていることをご確認ください。
        </p>
      </div>
      <div class="self_entry_by_guest" v-if="event.can_self_registration_guest">
        <button class="btn" type="button" @click="invertModalStatus">認証コード発行はこちら</button>
        <p>※入力いただいたメールアドレスに認証コードを送付いたします。</p>
      </div>
      <div class="login_switch_page">
        <router-link tag="button" :to="{name: 'UserLogin'}" class="btn">G-PLUSユーザーの方はこちら</router-link>
      </div>
    </div>
    <div class="loginForm_footer">
      <router-link :to="{name: 'AdminLogin'}">
        <span>管理者ログイン</span>
      </router-link>
    </div>
    <transition name="fade" v-if="event.can_self_registration_guest && showModal">
      <Modal @close="invertModalStatus">
        <div slot="content">
          <div class="guestRegisterForm_body">
            <validation-observer ref="registerObserver" v-slot="{handleSubmit, invalid}" class="form_body" v-if="!registerResult">
              <div class="inner">
                <form @submit.prevent="handleSubmit(storeGuest)">
                  <div v-if="registerError">
                    <span style="color: #ff0000;">{{ registerError }}</span>
                  </div>

                  <validation-provider rules="required|max:255" v-slot="{errors}" name="お名前" class="form-group">
                    <label for="name">お名前（フルネームでご記載下さい）</label>
                    <input type="text" id="name" name="name" v-model="registerForm.name" />
                    <ul v-if="errors.length">
                      <li v-for="(error, key) in errors" :key="key" class="error">{{ error }}</li>
                    </ul>
                  </validation-provider>

                  <validation-provider rules="required|max:255" v-slot="{errors}" name="所属" class="form-group">
                    <label for="organization_name">所属（歯科医院名、社名、部署名等をご記載下さい）</label>
                    <input type="text" id="organization_name" name="organization_name" v-model="registerForm.organization_name" />
                    <ul v-if="errors.length">
                      <li v-for="(error, key) in errors" :key="key" style="color: #ff0000;">{{ error }}</li>
                    </ul>
                  </validation-provider>

                  <validation-provider rules="required|email|max:255" v-slot="{errors}" name="メールアドレス" class="form-group">
                    <label for="email">メールアドレス</label>
                    <input type="text" id="email" name="email" v-model="registerForm.email" />
                    <ul v-if="errors.length">
                      <li v-for="(error, key) in errors" :key="key" style="color: #ff0000;">{{ error }}</li>
                    </ul>
                  </validation-provider>

                  <div class="button_area">
                    <button class="btn" type="submit" :disabled="invalid">ゲスト登録</button>
                  </div>
                </form>
                <span />
              </div>
            </validation-observer>
            <!-- ToDo: スタイル調整-->
            <div v-if="registerResult">
              <span>メールアドレスに認証コードを送付しました。</span>
              <button class="btn" type="button" @click="invertModalStatus(), invertRegisterResult()">閉じる</button>
            </div>
          </div>
        </div>
      </Modal>
    </transition>
  </section>
</template>

<script>
import RawHtml from "../elements/RawHtml"
import Modal from "../elements/Modal"

export default {
  name: "GuestLogin",
  components: {
    RawHtml,
    Modal
  },
  props: {
    slug: {
      type: String,
      required: true
    }
  },
  data: function() {
    return {
      loginForm: {
        auth_code_one: "",
        auth_code_two: ""
      },
      showModal: false,
      registerForm: {
        name: "",
        organization_name: "",
        email: ""
      },
      registerError: "",
      registerResult: false
    }
  },
  computed: {
    event() {
      return this.$store.getters["event/event"]
    },
    message() {
      return this.$store.getters["auth/message"]
    }
  },
  mounted() {
    this.$store.commit("loading/setLoading", false)
    this.setInputValueByUrlQuery()
  },
  methods: {
    login: async function() {
      this.$store.commit("loading/setLoading", true)

      await this.$store.dispatch("auth/login", {
        endpoint: `auth/${this.slug}/guest/login`,
        inputs: this.loginForm,
        validationObserver: this.$refs.observer,
        slug: this.slug
      })
    },
    invertModalStatus() {
      this.showModal = !this.showModal
    },
    storeGuest: async function() {
      this.$store.commit("loading/setLoading", true)

      await this.$axios
        .post(`auth/${this.slug}/guest`, this.registerForm)
        .then(response => {
          this.invertRegisterResult()
          this.registerForm.name = ""
          this.registerForm.organization_name = ""
          this.registerForm.email = ""
          this.registerError = ""
        })
        .catch(error => {
          const data = error.response.data
          const registerObserver = this.$refs.registerObserver
          console.log(error.response)
          if (Object.prototype.hasOwnProperty.call(data, "message") && data.message && error.response.status !== 422) {
            this.registerError = data.message
          }

          if (!Object.prototype.hasOwnProperty.call(data, "errors")) {
            return
          }

          // サーバサイドのバリデーションをループで回す
          for (let [fieldName, messages] of Object.entries(data.errors)) {
            // VeeValidatorのnameが日本語なので、検索する
            const field = Object.entries(registerObserver.refs)
              .find(([_, input]) => input.fieldName === fieldName)
              .pop()

            // 対象フィールドがあるか判定
            if (field) {
              // responseのエラーメッセージを設定
              registerObserver.setErrors({[field.id]: messages})
            }
          }
        })
        .finally(() => {
          this.$store.commit("loading/setLoading", false)
        })

      console.log(this.registerForm)
    },
    invertRegisterResult() {
      this.registerResult = !this.registerResult
    },
    setInputValueByUrlQuery() {
      this.loginForm.auth_code_one = this.$route.query.key1
      this.loginForm.auth_code_two = this.$route.query.key2
    }
  }
}
</script>

<style scoped></style>
